var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ranking_wrapper", attrs: { "data-chart": "ranking" } },
    [
      _vm.hasTimeline
        ? _c(
            "div",
            {
              staticClass: "app_timeline ranking_timeline",
              attrs: { "data-isplaying": _vm.isPlaying }
            },
            [
              _c("button", {
                staticClass: "timeline_bt",
                on: { click: _vm.togglePlay }
              }),
              _c("div", { staticClass: "timeline_year" }, [
                _vm._v(_vm._s(_vm.currentYear))
              ]),
              _c("v-slider", {
                staticClass: "timeline_slider",
                attrs: { min: _vm.minYear, max: _vm.maxYear },
                on: { start: _vm.dragStart, end: _vm.dragEnd },
                model: {
                  value: _vm.currentYear,
                  callback: function($$v) {
                    _vm.currentYear = $$v
                  },
                  expression: "currentYear"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "ranking_area",
          class: _vm.expandedRanking ? "expanded" : ""
        },
        [
          _c(
            "div",
            {
              staticClass: "loader lds-ellipsis",
              class: _vm.loaderDisplayed ? "displayed" : ""
            },
            [_c("div"), _c("div"), _c("div"), _c("div")]
          ),
          _vm._l(_vm.rankingSlots, function(countryObj, rankingIndex) {
            return _c("div", { staticClass: "ranking_slot" })
          }),
          _vm._l(_vm.rankingSlots, function(countryObj, rankingIndex) {
            return _c(
              "div",
              {
                staticClass: "country_bar_container",
                attrs: { "data-country": countryObj.countryCode }
              },
              [
                _c("div", { staticClass: "container_inner" }, [
                  _c("div", { staticClass: "country_label" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(countryObj.countryLabel) +
                        "\n                    "
                    ),
                    countryObj.years[String(_vm.currentYear)] != undefined &&
                    countryObj.years[String(_vm.currentYear)].value !=
                      "nodata" &&
                    countryObj.years[String(_vm.currentYear)].value != null
                      ? _c("div", { staticClass: "label_rank" })
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "country_bar" }, [
                    countryObj.years[String(_vm.currentYear)] != undefined
                      ? _c("div", { staticClass: "bar_value" }, [
                          countryObj.years[String(_vm.currentYear)].value ==
                            "nodata" ||
                          countryObj.years[String(_vm.currentYear)].value ==
                            null
                            ? _c("span", { staticClass: "value_nodata" }, [
                                _vm._v("No data")
                              ])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(
                                    countryObj.years[String(_vm.currentYear)]
                                      .displayedValue
                                  ) + _vm._s(_vm.indicatorUnit)
                                )
                              ])
                        ])
                      : _vm._e()
                  ])
                ])
              ]
            )
          })
        ],
        2
      ),
      _c("div", { staticClass: "ranking_expandbar" }, [
        _c(
          "div",
          {
            staticClass: "expandbar_bt",
            on: {
              click: function($event) {
                _vm.expandedRanking = !_vm.expandedRanking
              }
            }
          },
          [
            !_vm.expandedRanking
              ? _c("span", [_vm._v("Expand all ranking")])
              : _c("span", [_vm._v("Collapse all ranking")])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36558573", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36558573","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/rankingGraph.vue
// module id = sjG8
// module chunks = 0